import { render, staticRenderFns } from "./SupplierPerformance.vue?vue&type=template&id=e1168236&scoped=true"
import script from "./SupplierPerformance.vue?vue&type=script&lang=js"
export * from "./SupplierPerformance.vue?vue&type=script&lang=js"
import style0 from "./SupplierPerformance.vue?vue&type=style&index=0&id=e1168236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1168236",
  null
  
)

export default component.exports